var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"macroapp macroapp--page-common"},[(_vm.dynamicComponent)?_vm._m(0):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",attrs:{"page-config":_vm.dynamicComponentConfig}})
}]

export { render, staticRenderFns }